import {Component, inject, OnInit} from '@angular/core';
import {DialogBaseComponent} from "../dialog-base/dialog-base.component";
import {UIStateEnum} from "../../../enum/UIStateEnum";
import {FormControl, ReactiveFormsModule, Validators} from "@angular/forms";
import {MatError, MatFormField, MatLabel, MatHint} from "@angular/material/form-field";
import {MatSelect, MatOption} from "@angular/material/select";
import {MatInput} from "@angular/material/input";
import {NgIf, NgFor} from "@angular/common";
import {MatButton} from "@angular/material/button";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {DataAccessService} from "../../../services/data-access.service";
import {IDataAccessReasonType} from "../../../interfaces/audit/IDataAccessReasonType";
import {ErrorHandlingService} from "../../../services/error-handling.service";

@Component({
  selector: 'app-data-access-reason-dialog',
  standalone: true,
  imports: [
    DialogBaseComponent,
    MatFormField,
    MatSelect,
    MatOption,
    MatLabel,
    MatError,
    MatHint,
    MatInput,
    ReactiveFormsModule,
    NgIf,
    NgFor,
    MatButton
  ],
  templateUrl: './data-access-reason.component.html',
  styleUrl: './data-access-reason.component.css'
})
export class DataAccessReasonDialogComponent implements OnInit {

  private dialogRef = inject(MatDialogRef<DataAccessReasonDialogComponent>);
  private dataAccessService = inject(DataAccessService);
  private errorHandlingService = inject(ErrorHandlingService);
  public data = inject(MAT_DIALOG_DATA);

  public uiState = UIStateEnum.ShowLoading;
  public uiStateEnumForTemplate = UIStateEnum;

  public reasonControl = new FormControl<number | null>(null, Validators.required);
  public additionalDetailsControl = new FormControl<string>('');

  public availableReasons: IDataAccessReasonType[] = [];

  ngOnInit() {
    this.dataAccessService.getDataAccessReasonTypes().subscribe({
      next: (reasons) => {
        this.availableReasons = reasons.filter(r => r.Active);
        this.uiState = UIStateEnum.ShowData;
      },
      error: (err) => {
        this.uiState = UIStateEnum.ShowData;
        this.errorHandlingService.displayPageLevelErrorMessage(err);
      }
    });
  }

  canContinue(): boolean {
    return this.reasonControl.valid;
  }

  submit() {
    if (this.reasonControl.errors) {
      this.reasonControl.markAsTouched();
      return;
    }

    this.dialogRef.close({
      accessReason: this.reasonControl.value,
      additionalDetails: this.additionalDetailsControl.value || ''
    });
  }

  cancel() {
    this.dialogRef.close(false);
  }
}
